module.exports = __webpack_public_path__ + "img/cherimoya-350x184.d52fca26.jpg";